import React from 'react';
import PropTypes from 'prop-types';
import css from './CwToolbarFill.scss';

class CwToolbarFill extends React.Component {
  render() {
    return (<div data-cwid={this.props.cwId} className={css.toolbarFill}/>);
  }
}

CwToolbarFill.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
};

export default CwToolbarFill;


// WEBPACK FOOTER //
// ./src/components/cwtoolbar/CwToolbarFill.jsx